export class LoginService {
  async checkLogin(data) {
      const response = await fetch(`/api/checkLogin`, {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({loginData: data})
        })
      return await response.json();
  }
}
